import React from "react";
import PropTypes from "prop-types";
import InvalidFeedback from "../common/invalid_feedback";

function CompanyDetailForm(props) {
  const { show, company, companyPreviewLogoImage, defaultCompanyLogoImageUrl, onCompanyInputChange, onCompanyLogoImageChange } = props;

  return show === true && (
    <section id='add-company' className='my-4'>

      <p className='excuse text-center mb-4'>
        この会社のページを新規作成します
        <br />
        お手数ですが会社情報の入力をお願いします🙏
        <br />
        <span className='small'>(重複登録にご注意ください)</span>
      </p>

      <hr className='mb-5' />

      <div className='form-group row'>
        <label className='col-12 col-md-6 col-form-label' htmlFor='company-name-view'>
          会社名
        </label>
        <div className='col-12 col-md-6'>
          <input id='company-name-view' className='form-control' disabled='disabled' type='text' value={company.name} />
        </div>
      </div>

      <div className='form-group row'>
        <label className='col-12 col-md-6 col-form-label' htmlFor='company-concept-pitch'>
          企業理念
        </label>
        <div className='col-12 col-md-6'>
          <input
            name='concept_pitch'
            className={`form-control ${company.errors.concept_pitch ? "is-invalid" : ""}`}
            value={company.concept_pitch}
            onChange={event => onCompanyInputChange(event, company, event.target.value)}
            placeholder='投資機会を世界中の人々に'
            required='required'
            type='text'
            id='company-concept-pitch'
          />
          <InvalidFeedback errors={company.errors.concept_pitch} label='企業理念' />
        </div>
      </div>

      <div className='form-group row'>
        <label htmlFor='company-logo-image' className='col-12 col-md-6 col-form-label'>
          ロゴ
        </label>
        <div className='col-12 col-md-6'>
          <div className='custom-file mb-3'>
            <input
              name='logo_image'
              id='company-logo-image'
              className={`custom-file-input ${company.errors.logo_image ? "is-invalid" : ""}`}
              onChange={event => onCompanyLogoImageChange(event, company)}
              type='file'
            />
            <label className='custom-file-label' htmlFor='company-logo-image'>
              {companyPreviewLogoImage.file_name}
            </label>
            <InvalidFeedback errors={company.errors.logo_image} />
          </div>
          <img
            src={companyPreviewLogoImage.url || defaultCompanyLogoImageUrl}
            alt="ロゴ"
            className='logo-preview'
          />
        </div>
      </div>

      <div className='form-group row'>
        <label className='col-12 col-md-6 col-form-label' htmlFor='company-website-url'>
          WebサイトURL
        </label>
        <div className='col-12 col-md-6'>
          <input
            name='website_url'
            className={`form-control ${company.errors.website_url ? "is-invalid" : ""}`}
            value={company.website_url}
            onChange={event => onCompanyInputChange(event, company, event.target.value)}
            placeholder='https://yourcompany.com'
            type='text'
            id='company-website-url'
          />
          <InvalidFeedback errors={company.errors.website_url} label='WebサイトURL' />
        </div>
      </div>
    </section>
  );
}

CompanyDetailForm.propTypes = {
  show: PropTypes.bool.isRequired,
  company: PropTypes.shape({
    name: PropTypes.string.isRequired,
    concept_pitch: PropTypes.string.isRequired,
    website_url: PropTypes.string.isRequired,
    errors: PropTypes.object.isRequired
  }).isRequired,
  companyPreviewLogoImage: PropTypes.shape({
    file_name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
  }).isRequired,
  defaultCompanyLogoImageUrl: PropTypes.string.isRequired,
  onCompanyInputChange: PropTypes.func.isRequired,
  onCompanyLogoImageChange: PropTypes.func.isRequired
};

export default CompanyDetailForm;
